<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">首页</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li>页面上半部分显示【To Do】信息，显示分【个人】和【共通】，【个人】显示登录用户本人需要操作的业务数量，【共通】是系统中所有的需进行操作的业务数量</li>
          <li>页面右侧需要显示【通知（お知らせ）】信息，【通知】信息需要有维护页面来维护，通知需要区分可以看到的用户群组，并需要显示期限的控制</li>
          <li>页面下部为业务流程显示图标，按图标可以进入各业务的相关页面（取代Menu的作用）</li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
